<template>
    <div class="bg-white" style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <br />
            <CRow class="header-row mb-3 position-relative">
                <!-- Back Button on the Left -->
                <CCol class="col-auto">
                    <CButton class="back-button" @click="goBack">
                        ←
                    </CButton>
    
                </CCol>
    
                <!-- Centered Title -->
                <CCol class="d-flex flex-column align-items-center position-absolute start-50 translate-middle-x">
    
                    <h3 class="section-title m-0" v-for="item in detailIndustries.slice(0,1)" :v-bind:key="item.Id"> {{ item.category }}</h3>
                    <p class="custom-12px-500 font-color-928AFD mt-2">Good things to share</p>
                </CCol>
            </CRow>
            <div class="w-100 mt-5">
                <br />
                <CContainer>
                    <div>
                        <!-- Each Voucher gets its own CCard -->
                        <div v-for="user in detailIndustries" :key="user.voucherId">
                            <CCard class="custom-border-white p-3 rounded-3 shadow-sm" v-for="item in user.users" :key="item.id" @click="GoToDetailReview(item.sessionId)"  v-if="calculateAverageFromSummary(item.summary).average >= 5 && item.statusType && item.statusType.some(s => s.StatusType === 'Accepted')"
>
                                <CRow class="align-items-center p-2">
                              
                                    <!-- Left: Company Logo -->
                                    <CCol xs="4" class="d-flex justify-content-center">
                                        <img :src="item.profilePhoto" width="70px" />
                                    </CCol>
    
                                    <!-- Right: Company Details -->
                                    <CCol xs="8" class="ml-3">
                                        <!-- Rating Section (Same for Each Card) -->
                                        <div class="d-flex justify-content-between align-items-center w-100">
                                            <div class="absolute right-2 flex items-center space-x-1 bg-purple-600 rounded-lg">
                                                <img src="../assets/img/new/starorange.png" width="8px" class="relative" />
                                                <span class="custom-12px-500 text-muted ml-2">
                                        <!-- <span class="custom-14px-500 text-muted ml-2">5</span>
                                                <span class="custom-12px-500 font-color-A3A3A3">/5</span> -->
                                                </span>
    
                                              <span class="custom-14px-500 text-muted ml-2">
  {{ calculateAverageFromSummary(item.summary).average || 'N/A' }} 
</span>
                                            </div>
                                        </div>
    
                                        <!-- Users Section (Inside Each Voucher's CCard) -->
                                        <div class="d-flex align-items-center mt-2">
                                            <img src="../assets/img/no_img.png" width="30px" class="mr-2 rounded-circle" />
                                            <div class="d-flex flex-column">
                                                <span class="custom-12px-500 font-color-191919">– {{ item.name }} ({{ item.codeVoucher }})</span>
                                                <span class="text-muted custom-12px-500">{{ item.email }}</span>
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </div>
                    </div>
                    <br /><br />
                </CContainer>
                <Footerlayout />
            </div>
        </CContainer>
    
    </div>
</template>


<script>
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";

export default {
    components: {
        Mainlayout,
        Footerlayout,
    },
    data() {
        return {
            detailIndustries: []
        };
    },
    mounted() {
        this.GetDetailIndustries();

    },
    methods: {
        goBack() {
            this.$router.push("Home"); // Navigate to the previous page
        },
        openPopup(video) {
            this.selectedVideo = video;
            this.isPopupDetail = true;
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        deleteVideo() {
            this.isPopupDelete = true;
        },
        shareVideo() {
            this.isPopupShareLink = true;
        },
        openSuccess() {
            this.isPopupSuccess = true;
            this.isPopupDelete = false;
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            }
        },
        GoToDetailReview(id) {
            this.$router.push("DetailReview" + "?id=" + id);
        },
        async GetDetailIndustries() {
            try {
                const response = await this.$API.get(this.$GetDetailVoucherPerIndustryAndCompany + "?id=" + this.$route.query.id + "&companyId=" + this.$route.query.companyId, {
                    withCredentials: true,
                });

                console.log("API Response:", response.data); // Debugging

                if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
                    this.detailIndustries = response.data;
                } else {
                    console.warn("No valid data returned from API.");
                    this.detailIndustries = []; // Ensure no empty objects cause rendering issues
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                this.detailIndustries = []; // Handle API errors gracefully
            }
        },
        calculateAverageFromSummary(summary) {
                if (!summary) return { average: null, totalCategories: 0 };

                const ratingMatches = summary.match(/(\d+)\/10/g);

                if (!ratingMatches) return { average: null, totalCategories: 0 };

                let total = 0;
                let count = ratingMatches.length;

                ratingMatches.forEach(rating => {
                    total += parseInt(rating.split("/")[0], 10);
                });

                const avg = total / count;

                return {
                    average: parseFloat(avg.toFixed(1)),
                    totalCategories: count
                };
            }

    }
};
</script>

